<template>
<div v-show="isModalVisible">
<div class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header">
        <h6 class="modal-title">Affiliate Subscription Details</h6>
        <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <div class="heading_1 margin-bottom-10">
          Affiliate Name: <span style="font-weight:normal">{{ affiliateName }}</span>
        </div>
        <div class="p-0 col-12" v-if="license.expireDate > 0">
        <div class="heading_1  margin-bottom-10">
          {{ license.unitType }}
        </div>
        <div class="col-6 p-0 float-left">
          <div class="heading_2  margin-bottom-5">
            Name: <span style="font-weight:normal">{{ license.name }}</span>
          </div>
          <div class="heading_2  margin-bottom-5">
            Validity Duration: <span style="font-weight:normal">{{ license.expireDate }} months</span>
          </div>
          <div class="heading_2  margin-bottom-5" v-if="license.licenseType == 'Bundle License'">
            Minimum License: <span style="font-weight:normal">{{ license.minLicense }}</span>
          </div>
          <div class="heading_2  margin-bottom-5" v-if="license.licenseType == 'Bundle License'">
            Bundle Price: <span style="font-weight:normal">${{ license.bundlePrice }}</span>
          </div>
          <div class="heading_2  margin-bottom-5" v-if="license.licenseType == 'Bundle License'">
            After Bundle Price: <span style="font-weight:normal">${{ license.afterBundlePrice }}</span>
          </div>
        </div>
        <div class="col-6 p-0 float-left" v-if="license.unitType == 'License'">
          <div class="heading_2  margin-bottom-5">
            Reassign Window: <span style="font-weight:normal">{{ license.reassignWindow }} days</span>
          </div>
          <div class="heading_2  margin-bottom-5">
            # of Reassign: <span style="font-weight:normal">{{ license.noReassign }}</span>
          </div>
          <div class="heading_2  margin-bottom-5">
            Probation Window: <span style="font-weight:normal">{{ license.probationWindow }} days</span>
          </div>
        </div>
        <div style="clear: both;"></div>

        <div class="heading_2  margin-bottom-5" v-if="license.licenseType == 'Normal License'">
          Tier Price
        </div>
        <div class="col-12 heading_2 p-0" style="width: 100%;" v-if="license.licenseType == 'Normal License'">
          <div style="width: 30%" class="float-left">
            From
          </div>
          <div style="width: 30%" class="float-left">
            To
          </div>
          <div style="width: 40%" class="float-left">
            Seat Price
          </div>
        </div>
        <div 
        <div class="col-12 heading_2 p-0" style="font-weight: normal; width: 100%;" v-for="(price, index) in license.price" :key="index" >
          <div style="width: 30%" class="float-left">
            {{ price.license_from }}
          </div>
          <div style="width: 30%" class="float-left">
            {{ price.license_to }}
          </div>
          <div style="width: 40%" class="float-left">
            {{ price.license_price }}
          </div>
        </div>
        </div>
        <div style="clear: both" ></div>


        <div class="heading_2  margin-bottom-5" v-if="license.unitType == 'Seat'">
          Price
        </div>
        <div class="col-12 heading_2 p-0" style="width: 100%;" v-if="license.unitType == 'Seat'">
          <div style="width: 15%" class="float-left">
            Qty
          </div>
          <div style="width: 25%" class="float-left">
            Yearly Price
          </div>
          <div style="width: 25%" class="float-left">
            Monthly Price
          </div>
          <div style="width: 15%" class="float-left">
            Max Seat
          </div>
          <div style="width: 20%" class="float-left">
            Discount
          </div>
        </div>
        <div >
        <div class="col-12 heading_2 p-0" style="font-weight: normal; width: 100%;" v-for="(price, sindex) in license.seatPrice" :key="sindex" >
          <div style="width: 15%" class="float-left" v-if="price.license_qty == 0">
            Unlimited
          </div>
          <div style="width: 15%" class="float-left" v-else>
            {{ price.license_qty }}
          </div>
          <div style="width: 25%" class="float-left">
            {{ price.license_yearly_price }}
          </div>
          <div style="width: 25%" class="float-left">
            {{ price.license_monthly_price }}
          </div>
          <div style="width: 15%" class="float-left">
            {{ price.max_seat }}
          </div>
          <div style="width: 20%" class="float-left">
            {{ price.discount }}
          </div>
        </div>
        </div>
        <div style="clear: both" ></div>
        <div class="col-6 p-0 float-left pt-3" v-if="license.unitType == 'Seat'">
          <div class="heading_2  margin-bottom-5">
            Additional Seat Yearly Price: <span style="font-weight:normal">{{ license.additionalYearlyPrice }}</span>
          </div>
          <div class="heading_2  margin-bottom-5">
            Additional Seat Monthly Price: <span style="font-weight:normal">{{ license.additionalMonthlyPrice }}</span>
          </div>
        </div>

        <div v-if="(license.expireDate > 0 && otp.price > 0)" style="border-bottom: 1px solid #00ACEE; margin: 10px 0;" ></div>
        <div class="p-0 col-12" v-if="otp.price > 0">
        <div class="heading_1  margin-bottom-10">
          One Time Purchase
        </div>
        <div class="heading_2  margin-bottom-5">
          Licence Name: <span style="font-weight:normal">{{ otp.name }}</span>
        </div>
        <div class="heading_2  margin-bottom-5">
          Price: <span style="font-weight:normal">{{ otp.price }}</span>
        </div>
        </div>


      </div>
     </div>

</div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';

export default {
  props: [
    'isModalVisible',
    'affiliateId',
    ],
  data() {
    return {
        loading: false,
        license: [],
        otp: [],
        affiliateName: '',
    }
  },
  methods: {
    closeModal() {
      this.$validator.errors.clear();
      this.$emit('close');
    },
    navigate(){
        this.$router.push(this.$router.currentRoute.fullPath)
        this.$router.go();
    },
    getSubscriptionDetails(affiliateId) {
      this.license = [];
      this.otp = [];
      this.affiliateName = '';
      axios.get('/affiliatelists/' + affiliateId)
      .then((resp) => {
          this.loading = false;   
          this.license = resp.data.license;
          this.otp = resp.data.otp; 
          this.affiliateName = resp.data.affiliateName;        
      })
      .catch(error => {

      });
    },
  },
  created() {

  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  height: auto;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  min-height: 300px;
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.btn-danger {
  background-color: #00ACEE;
  border-color: #00ACEE;
}
.modal-title {
  color: #7d7d7d;
  font-size: 14px;
  font-weight: 900;
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.heading_1 {
    font-size: 14px;
    font-weight: bold;
}
.heading_2 {
    font-size: 12px;
    font-weight: bold;
}
.form-control { font-size: 14px; }
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/account_lookup_affiliate_price_modal.vue